import {Offers} from '../widgets/Offers'
import {OffersNDD} from '../widgets/OffersNDD/index@desktop'
import {Options} from '../widgets/Options/index@desktop'
import {Parcel} from '../widgets/Parcel/index@desktop'
import {Route} from '../widgets/Route/index@desktop'
import type {Section} from '../widgets/types'
import {Verticals} from '../widgets/Verticals/index@desktop'

export const hasAnyWidgetId =
  (...widgetIds: string[]) =>
  (section: Section) =>
    section.widgets?.some(widget => widget.widget_id && widgetIds.includes(widget.widget_id)) || false

type SectionMatcher = {
  predicate: (section: Section) => boolean
  component: React.ComponentType<{section: Section}>
}

const SECTION_MATCHES: SectionMatcher[] = [
  {
    predicate: hasAnyWidgetId(
      'cargo_c2c_order_forms_b2b_lk_cargo_verticals_widget',
      'cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget',
    ),
    component: Verticals,
  },
  {
    predicate: hasAnyWidgetId(
      'cargo_c2c_order_forms_b2b_lk_cargo_route_section_header',
      'cargo_c2c_order_forms_b2b_lk_ndd_self_pickup_route_section_header',
    ),
    component: Route,
  },
  {
    predicate: hasAnyWidgetId('cargo_c2c_order_forms_b2b_lk_cargo_options_section_header'),
    component: Options,
  },
  {
    predicate: hasAnyWidgetId('cargo_c2c_order_forms_b2b_lk_ndd_offers_section_header'),
    component: OffersNDD,
  },
  {
    predicate: hasAnyWidgetId('cargo_c2c_order_forms_b2b_lk_ndd_options_section_header'),
    component: Parcel,
  },
  {
    predicate: hasAnyWidgetId('cargo_c2c_order_forms_b2b_lk_cargo_offers_section_header'),
    component: Offers,
  },
]

export const matchSection = (section: Section) => {
  const matcher = SECTION_MATCHES.find(({predicate}) => predicate(section))
  return matcher ? matcher.component : null
}
